import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, rydeColors } from "@ryde/theme";

export const NotFoundPageStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "not-found-page",
})`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${rydeColors.white};

  .not-found__block {
    width: 480px;
    padding: 32px;
    border-radius: 16px;
    background-color: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
      font-size: 24px;
      font-weight: 600;
      margin-top: 16px;
      color: ${blueGreyMui._800};
    }

    p {
      font-size: 16px;
      color: ${blueGreyMui._700};
      margin: 12px 0;
    }

    .not-found__return-link {
      font-size: 15px;
      margin-top: 20px;
      text-decoration: underline;
      color: ${blueGreyMui._900};
    }

    .emoji {
      font-size: 40px;
      margin-bottom: 12px;
    }

    .icon {
      font-size: 56px;
      color: ${blueGreyMui._800};
    }
  }
`;
